module.exports = __webpack_public_path__ + "static/media/logo.340d22e1.jpeg";